if (document.querySelector('.cart-toggle-btn')) {
    document.querySelectorAll('.cart-toggle-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            const target = btn.getAttribute('data-target'); // 'cart' or 'wishlist'
            const cartContent = document.querySelector('[data-toggler="cart"]');
            const wishlistContent = document.querySelector('[data-toggler="wishlist"]');

            document.querySelectorAll('.cart-toggle-btn').forEach(function(otherBtn) {
                otherBtn.removeAttribute('is-displayed');
            });

            if (target === 'cart') {
                btn.setAttribute('is-displayed', '');
                cartContent.setAttribute('is-displayed', '');
                wishlistContent.removeAttribute('is-displayed');
            } else if (target === 'wishlist') {
                btn.setAttribute('is-displayed', '');
                wishlistContent.setAttribute('is-displayed', '');
                cartContent.removeAttribute('is-displayed');

                // Trigger lazy load for wishlist items images
                observeLazyImages();
            }
        });
    });
}

if (document.querySelector('.cart-recap-title[is-collapsible]')) {
    document.querySelector('.cart-recap-title[is-collapsible]').addEventListener('click', function() {
        const recapProducts = document.querySelector('.cart-recap-line.recap-products');
        if (recapProducts.hasAttribute('is-collapsed')) {
            this.setAttribute('is-expanded', '');
            slideDown(recapProducts);
            // Trigger lazy load for wishlist items images
            observeLazyImages();
        } else {
            this.removeAttribute('is-expanded');
            slideUp(recapProducts);
        }
    });
}

function isUrlValid(string) {
    try {
        new URL(string);
        return true;
    } catch (err) {
        return false;
    }
}

function tunnelDisconnect(disconnectFromTunnel = false) {
    fetch(path_relative_root + 'ajax_deconnect.php?redirect_after=order_identification&disconnectFromTunnel=' + disconnectFromTunnel)
        .then(() => {
            document.location.href = path_relative_root + create_link('order_identification');
        });
}

function mySubmit(pType) {
    var form = document.getElementById("formPanier");

    document.querySelector(".btn-validate-order").setAttribute("is-loading", "");

    form.action = create_link("order_basket");

    setTimeout(function () {
        form.submit();
    }, 0);
}

function refreshCart(params, reloadWishlist) {
    (async function() {
        try {
            const response = await fetch(path_relative_root + create_link('order_basket'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams(params).toString(),
                cache: 'no-store'
            });
            const res = await response.text();
            let json;
            try {
                json = JSON.parse(res);
            } catch (e) {
                console.error('JSON ERROR: could not parse data');
                return false;
            }

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = json.datas;

            const cartNbProductsElement = tempDiv.querySelector('.cart-main-title');
            const cartNbProducts = (cartNbProductsElement && cartNbProductsElement.querySelector('.nb-products')) ? parseInt(cartNbProductsElement.querySelector('.nb-products').innerHTML) : 0;
            const cartProductsContent = tempDiv.querySelector('.cart-products-content');
            const outOfStockTable = tempDiv.querySelector('.cart_out_of_stock_table');

            if (document.querySelector('.cart-main-title')) {
                document.querySelector('.cart-main-title').innerHTML = cartNbProductsElement.innerHTML;
            }

            if (outOfStockTable && document.querySelector('.cart_out_of_stock_table')) {
                document.querySelector('.cart_out_of_stock_table').innerHTML = outOfStockTable.innerHTML;
            }

            if (cartProductsContent) {
                document.querySelector('.cart-products-content').innerHTML = cartProductsContent.innerHTML;

                toggleCartRecap(cartNbProducts);

            } else {
                document.querySelector('.cart-products-content').innerHTML = "<div class=\"cart-empty\">" + Translator.translate("basket_empty") + "</div>";

                toggleCartRecap(cartNbProducts);
            }

            const cartSummary = tempDiv.querySelector('.cart-summary');
            if (cartSummary) {
                document.querySelector('.cart-summary').innerHTML = cartSummary.innerHTML;
            }

            if (typeof wShop !== 'undefined' && wShop.$refs.wCouponForm) {
                wShop.$refs.wCouponForm.reloadBloc+=1;
            }

            // Update header cart display
            await updateHeaderCart();

            if (reloadWishlist) {
                const cartNbWishlist = tempDiv.querySelector('.cart-wishlist-title');
                const cartWishlistContent = tempDiv.querySelector('.cart-wishlist-content');

                if (document.querySelector('.cart-wishlist-title') && cartNbWishlist) {
                    document.querySelector('.cart-wishlist-title').innerHTML = cartNbWishlist.innerHTML;
                }

                if (document.querySelector('.cart-wishlist-content') && cartWishlistContent) {
                    document.querySelector('.cart-wishlist-content').innerHTML = cartWishlistContent.innerHTML;
                }
            }
        } finally {
            if (typeof initApplePayExpressCheckout === "function") {
                initApplePayExpressCheckout();
            }

            // Trigger item sliders load
            initializeItemSliders();

            var evt = new CustomEvent("refreshCart_complete");
            window.dispatchEvent(evt);
        }
    })();
}

async function updateHeaderCart() {
    // Update header cart display

    const ajaxUpdate = fetch(path_relative_root + 'ajax_show_basket.php', {method: 'GET', credentials: 'same-origin'});
    const userCart = await ajaxUpdate.then(response => response.text());

    const cartTop = document.querySelector('.top-cart');
    if (cartTop) {
        cartTop.innerHTML = userCart;
    }

}

function toggleCartRecap(nbProducts) {
    if (nbProducts > 0) {
        if (document.querySelector('.cart-wrapper').hasAttribute('is-empty')) {
            document.querySelector('.cart-wrapper').removeAttribute('is-empty');
        }
    } else {
        if (!document.querySelector('.cart-wrapper').hasAttribute('is-empty')) {
            document.querySelector('.cart-wrapper').setAttribute('is-empty', '');
        }
    }
}

function changeQte(type) {
    let types = ['plus', 'less'];
    let item;
    let qtty;

    if (types.includes(type)) {
        item = this.querySelector('input[name="item_id"]').value;
        qtty = parseFloat(this.querySelector('input[name="selected_qte"]').value);

        this.querySelector('.cart-item-quantity-change').setAttribute('is-processing', '');

        switch (type) {
            case 'plus':
                qtty = qtty + 1;
                break;
            case 'less':
                qtty = qtty - 1;
                break;
        }

        fetch(path_relative_root + create_link("order_basket"), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                action: 'del',
                panierId: item,
                cad: 'non',
                pointcad: 0,
                qteProd: qtty,
                change_qte: true
            }).toString(),
            cache: 'no-store'
        })
        .then(response => response.text())
        .then(async res => {
            let json;
            try {
                json = JSON.parse(res);
            } catch (e) {
                console.error('JSON ERROR: could not parse data');
                return false;
            }

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = json.datas;

            const cartWrapper = tempDiv.querySelector('.cart-wrapper');
            if (cartWrapper) {
                document.querySelector('.cart-wrapper').innerHTML = cartWrapper.innerHTML;
            }

            if (wShop.$refs.wCouponForm) {
                wShop.$refs.wCouponForm.reloadBloc += 1;
            }

            // Update header cart display
            await updateHeaderCart();

            if (typeof initApplePayExpressCheckout === "function") {
                initApplePayExpressCheckout();
            }

            if (json.error_message && json.error_message.length) {
                const modboxpromo = document.getElementById('modboxpromo');
                if (modboxpromo) {
                    const texte = modboxpromo.querySelector('.texte');
                    if (texte) {
                        texte.innerHTML = json.error_message;
                        if (typeof openModal === "function") {
                            openModal('modboxpromo');
                        }
                    }
                }
            }
        })
        .finally(() => {
            if (typeof getWishlistProducts === "function") {
                getWishlistProducts();
            }

            // Create CustomEvent "changeQteBasket_success" to provide extra scripts
            var evt = new CustomEvent("changeQteBasket_success");
            window.dispatchEvent(evt);
        });
    }
}

function removeFromBasket(removeBtn, reloadWishlist, emptyCart) {

    removeBtn.closest('.cart-product-item').setAttribute('is-processing', '');

    var panierId = removeBtn.getAttribute("data-panierId");
    var cad = removeBtn.getAttribute("data-cad");
    var pointcad = removeBtn.getAttribute("data-pointcad");
    var qteProd = removeBtn.getAttribute("data-qteProd");

    var service, spe, isDonation;
    if (removeBtn.hasAttribute("data-service")) {
        service = removeBtn.getAttribute("data-service");
    }
    if (removeBtn.hasAttribute("data-spe")) {
        spe = removeBtn.getAttribute("data-spe");
    }
    if (removeBtn.hasAttribute("data-is-product-donation")) {
        isDonation = removeBtn.getAttribute("data-is-product-donation");
    }

    var params = {
        action: 'del',
        panierId: panierId,
        cad: cad,
        pointcad: pointcad,
        qteProd: qteProd,
        returnHtml: "ajax"
    };

    var typeRedirect = (new URL(location.href)).searchParams.get('type_redirect');

    if (typeRedirect === 'out_of_stock') {
        params.type_redirect = 'out_of_stock';
    }

    if (emptyCart) {
        params.emptyCart = emptyCart;

        // dataLayer Empty cart Event
        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    'event': 'emptyCart',
                });
            }

        } catch (e) {
            console.error(e);
        }
    }
    if (service) {
        params.service = service;
    }
    if (spe) {
        params.spe = spe;
    }
    if (isDonation) {
        params.isDonation = isDonation;
    }

    refreshCart(params, reloadWishlist);

    if (emptyCart) {
        window.scrollTo({ top: 0, behavior: 'fast' });
    }

    // Create CustomEvent "removeFromBasket_success" to provide extra scripts
    var evt = new CustomEvent("removeFromBasket_success");
    window.dispatchEvent(evt);
}

function basketToWish(btn, removeFromCart = true) {
    var cartItem = btn.closest('.cart-product-item');
    cartItem.setAttribute('is-processing', '');

    var productId = cartItem.getAttribute("data-product-id");
    var sizeId = cartItem.getAttribute("data-size-id");
    var colorId = cartItem.getAttribute("data-color-id");

    let datas = new URLSearchParams({
        product_id: productId,
        color_id: colorId,
        size_id: sizeId,
        need_color_id: 'true',
        need_size_id: 'true'
    });

    if (!checkItemInWishlist(cartItem)) {
        fetch(path_relative_root + "ajax_add_to_wishlist.php" + '?time=' + Date.now(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: datas.toString()
        })
        .then(response => response.json())
        .then(async resp => {
            if (resp.error) {
                cartItem.removeAttribute('is-processing');
                alert(Translator.translate(resp.message));
                return false;
            } else {
                // DataLayer

                if (resp.result.dlv3_wishlist_item) {
                    var dl_v3_obj = resp.result.dlv3_wishlist_item;
                    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && Object.keys(dl_v3_obj).length > 0) {
                        DataLayerTrigger.addToWishList(dl_v3_obj['items'], dl_v3_obj['actionField']);
                    }
                }

                if (typeof wishlist !== 'undefined') {
                    wishlist = [];
                    wishlist.push(resp.result.wishlist_row_array);
                }

                const ajaxUpdate = await fetch(path_relative_root + 'ajax_show_wishlist.php');
                const userWishlist = await ajaxUpdate.text();

                const wishlistTop = document.querySelector(".top-wishlist");
                if (wishlistTop) {
                    wishlistTop.innerHTML = userWishlist;
                }

                if (removeFromCart) {
                    removeFromBasket(btn, true);
                    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && productId !== null && productId !== undefined && dl_v3_impressions !== undefined) {
                    DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, productId, "remove_from_cart");
                    }
                } else if (!removeFromCart) {
                    cartItem.querySelector('.cart-item-to-wishlist').setAttribute('in-wishlist', '');
                }

                const cartWishlist = document.querySelector('.cart-wishlist-title');
                if (cartWishlist) {
                    const nbProducts = cartWishlist.querySelector('.nb-products');
                    if (nbProducts) {
                        nbProducts.innerHTML = resp.result.wishlist_size;
                    }
                }

                // Scroll to the added wishlist product
                const wishProductItem = document.querySelector(`.cart-wishlist-item[data-product-id="${productId}"]`);
                if (wishProductItem) {
                    wishProductItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                // Create CustomEvent "basketToWish_success" to provide extra scripts
                var evt = new CustomEvent("basketToWish_success");
                window.dispatchEvent(evt);
            }
        });
    } else {
        alert(Translator.translate('wishlist_already_in_wishlist'));
        cartItem.removeAttribute('is-processing');
    }
}

function wishToBasket(btn) {

    var url = path_relative_root + create_link('order_basket');

    var typeRedirect = (new URL(location.href)).searchParams.get('type_redirect');

    if (typeRedirect == 'out_of_stock') {
        url += '?type_redirect=out_of_stock';
    }

    var wishItem = btn.closest('.cart-wishlist-item');
    wishItem.setAttribute('is-processing', '');

    var selectedProducts = btn.getAttribute("data-id");
    var prodId = btn.getAttribute("data-product-id");
    var colorId = btn.getAttribute("data-color-id");
    var sizeId = btn.getAttribute("data-size-id");

    let datas = {
        data: selectedProducts,
    };

    if (prodId !== undefined) {
        datas.productId = prodId;
    }

    if (colorId !== undefined) {
        datas.colorId = colorId;
    }

    if (sizeId !== undefined) {
        datas.sizeId = sizeId;
    }

    fetch(path_relative_root + create_link('ajax_add_panier_wishlist'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams(datas).toString(),
        cache: 'no-store'
    })
    .then(response => response.text())
    .then(async resp => {
        if (resp == "ok") {
            if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && prodId !== undefined && typeof dl_v3_wishlist_impressions !== 'undefined' && dl_v3_wishlist_impressions !== undefined) {
                DataLayerTrigger.wishlist_cart_product_action(dl_v3_wishlist_impressions, dlv3_action_wishlist_fields, prodId, "add_to_cart");
            }

            const basketResponse = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({ returnHtml: "ajax" }).toString(),
                cache: 'no-store'
            });
            let res = await basketResponse.text();

            try {
                res = JSON.parse(res);
            } catch (e) {
                console.error('JSON ERROR: could not parse data');
                return false;
            }

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = res.datas;

            const basketTable = tempDiv.querySelector('.cart-products');
            const wishlistTable = tempDiv.querySelector('.cart-wishlist');
            const tunnelRightCol = tempDiv.querySelector('.cart-summary');

            if (basketTable && document.querySelector('.cart-products')) {
                document.querySelector('.cart-products').innerHTML = basketTable.innerHTML;
            }
            if (wishlistTable && document.querySelector('.cart-wishlist')) {
                document.querySelector('.cart-wishlist').innerHTML = wishlistTable.innerHTML;
            }
            if (tunnelRightCol && document.querySelector('.cart-summary')) {
                document.querySelector('.cart-summary').innerHTML = tunnelRightCol.innerHTML;
            }

            if (typeof wShop !== 'undefined' && wShop.$refs.wCouponForm) {
                wShop.$refs.wCouponForm.reloadBloc += 1;
            }

            await updateHeaderWishlist();

            await updateHeaderCart();

            // Scroll to the added cart product
            const cartProductItem = document.querySelector(`.cart-product-item[data-product-id="${prodId}"]`);
            if (cartProductItem) {
                cartProductItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            // Create custom event on success in order to do extra script on client side
            var wishToBasket_success = new CustomEvent("wishToBasket_success", { detail: { nbWishlist: tempDiv.querySelectorAll('.cart-wishlist-content .cart-wishlist-item').length } });
            window.dispatchEvent(wishToBasket_success);
        }
    });
}

async function basketChangeSize(form) {
    let basketId = form.elements['panierId'].value;
    let productId = form.elements['product_id'].value;
    let colorId = form.elements['color_id'].value;
    let sizeId = form.elements['size_id'].value;
    let from = form.elements['from'].value;
    let qteProd = form.elements['qteProd'].value;
    var quantity = parseInt(qteProd);

    form.closest('.cart-product-item').setAttribute('is-processing', '');

    let data = {
        idprod: productId,
        idcouleur: colorId,
        idtaille: sizeId,
        qte: quantity,
        dataTypeReturn: 'json'
    };

    try {
        const response = await fetch(path_relative_root + 'ajax_upd_panier.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams(data).toString()
        });
        const res = await response.json();
        if (res.error !== 0) {
            alert(res.error.msg);
        } else {
            // Suppression de l'ancien panier
            removeBasketItem(basketId);
        }
    } catch (e) {
        console.error(e);
    }
}

async function removeBasketItem(basketId) {
    let datas = {
        action: 'del',
        panierId: basketId,
        cad: 'non',
        pointcad: 0,
        returnHtml: "ajax"
    };

    try {
        const response = await fetch(path_relative_root + create_link('order_basket'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams(datas).toString(),
            cache: 'no-store'
        });
        let res = await response.text();
        try {
            res = JSON.parse(res);
            let content = res.datas;
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
            const newTable = tempDiv.querySelector('.cart-products');
            const cartTable = document.querySelector('.cart-products');
            if (newTable && cartTable) {
                cartTable.innerHTML = newTable.innerHTML;
            }

            // Trigger item sliders load
            initializeItemSliders();
            observeLazyImages();

            var evt = new CustomEvent("removeBasketItemCustom");
            window.dispatchEvent(evt);
        } catch (e) {
            console.error('JSON ERROR: could not parse data');
            return false;
        }
    } catch (e) {
        console.error(e);
    }
}

// Datalayer delete product
function removeFromCart(rank) {
    if (typeof productFieldObject !== 'undefined' && productFieldObject !== '') {
        var product = productFieldObject[rank];

        product.quantity = 1;

        if (typeof dataLayer_v3 !== 'undefined' && typeof dl_v3_impressions !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && product.id !== null && product.id !== undefined) {
            DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, product.id, "remove_from_cart", product.quantity);
        }

        var new_dataLayer = dataLayer[1];
        if (new_dataLayer !== null && new_dataLayer !== undefined && (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '1')) {
            new_dataLayer.ecommerce.checkout.products[rank].quantity = parseFloat(document.getElementsByClassName('selected_qte')[rank].value) - 1;
            pushToWshopBus(new_dataLayer);
            dataLayer[1] = new_dataLayer;
        }
    }
}

function deleteFromCart(rank, qty) {
    if (typeof productFieldObject !== 'undefined' && productFieldObject !== '') {
        var product = productFieldObject[rank];

        product.quantity = parseInt(qty);
        pushToWshopBus({
            "event": "removeFromCart",
            "ecommerce": {
                "remove": {
                    "products": [product]
                }
            }
        });
    }
}

function deleteItemFromCart (id, qty) {
    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && id !== null && id !== undefined) {
        DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, id, "remove_from_cart", qty);
    }
}

/*
 * Delivery choice
 */
function splitThousands(nmbr) {
    nmbr = String(nmbr);
    let chunk_length = nmbr.length % 3;
    let f_chunk = chunk_length ? nmbr.slice(0, chunk_length) : '';
    let rest = nmbr.substr(chunk_length);
    let formatted = rest.replace(/\d{3}/g, match => ' ' + match);
    return f_chunk + formatted;
}

function getFormattedPrice(amount, fieldSelector, labelZero) {
    let field = document.querySelector(fieldSelector);
    if (!field) {
        return;
    }
    let priceFormatTunnel = $(price_format_plain_tunnel);
    let centFormatTunnel = priceFormatTunnel.find('.number_cent');
    let comma = centFormatTunnel.length ? centFormatTunnel.find('.comma') : null;
    comma = comma ? comma.html() : '';

    let stringifyAmount = amount.toString();
    let amounts = stringifyAmount.split('.');

    if (amounts[0] > 0) {
        let cents = amounts[1] ? amounts[1] : '00';
        cents = cents.toString();
        if (cents == 0) {
            cents = '00';
        } else if (cents.length == 1) {
            cents += '0';
        }

        priceFormatTunnel.find('.unit').html(amounts[0]);

        let centFormat = cents;
        if (comma !== '') {
            centFormat = comma + centFormat;
        }

        if (centFormatTunnel) centFormatTunnel.html(centFormat);
        if (field) {
            field.innerHTML = priceFormatTunnel.html();
        }

        if (cents > 0) {
            let nc = field.querySelector('.number_cent');
            if (nc) nc.classList.remove('no_cents');
        } else {
            let nc = field.querySelector('.number_cent');
            if (nc) nc.classList.add('no_cents');
        }
    } else {
        field.innerHTML = labelZero;
        field.classList.remove('not_eligible');
    }
}

function chooseTransporteur(conveyorElem, conveyor_id) {
    const obj = conveyorElem;
    let dataTransporteur = obj.getAttribute('data-id-transporteur');
    let deliveryChoice = obj.closest('.delivery_choice');
    let deliveryModeSelected = deliveryChoice ? deliveryChoice.getAttribute("data-delivery-mode") : null;
    let relayType = obj.getAttribute('data-relay-type') !== null ? obj.getAttribute('data-relay-type') : 0;

    if (dataTransporteur === undefined || dataTransporteur === null) {
        dataTransporteur = conveyor_id;
    }

    const deliveryTypeBtn = document.querySelector('.delivery-type-btn[data-delivery-type="' + deliveryModeSelected + '"]');
    if (deliveryTypeBtn && !deliveryTypeBtn.classList.contains('selected')) {
        deliveryTypeBtn.click();
    }

    let fdp, corse, label_zero, is_relay;
    try {
        fdp = array_transporteurs_datas[dataTransporteur]['fdp'];
        corse = array_transporteurs_datas[dataTransporteur]['supplement_corse'];
        label_zero = array_transporteurs_datas[dataTransporteur]['label_zero'];
        is_relay = array_transporteurs_datas[dataTransporteur]['is_relay'];
    } catch (e) {
        return false;
    }

    let $price_format_plain_tunnel = $(price_format_plain_tunnel);

    let fdp_txt = document.getElementById('fdp-txt');
    let fdp_to_calc = 0;
    let cent_format_plain_tunnel = $price_format_plain_tunnel.find('.number_cent');
    let comma = cent_format_plain_tunnel.length ? cent_format_plain_tunnel.find('.comma') : null;
    comma = comma ? comma.html() : '';

    if (fdp[0] > 0) {
        let fdp_cent = fdp[1] ? fdp[1] : '00';
        fdp_cent = fdp_cent.toString();
        if (fdp_cent == 0) {
            fdp_cent = '00';
        } else if (fdp_cent.length == 1) {
            fdp_cent += '0';
        }

        $price_format_plain_tunnel.find('.unit').html(fdp[0])

        let fdp_cent_format = fdp_cent;
        if (comma !== '') {
            fdp_cent_format = comma + fdp_cent_format;
        }

        if (cent_format_plain_tunnel) cent_format_plain_tunnel.html(fdp_cent_format);
        if (fdp_txt) {
            fdp_txt.innerHTML = '<span class="fdp-sign">+&nbsp;</span>' + $price_format_plain_tunnel.html();
            fdp_txt.classList.add('not_eligible');
        }

        if (fdp_cent > 0) {
            let nc = fdp_txt.querySelector('.number_cent');
            if (nc) nc.classList.remove('no_cents');
        } else {
            let nc = fdp_txt.querySelector('.number_cent');
            if (nc) nc.classList.add('no_cents');
        }

        fdp_to_calc = parseFloat(fdp[0] + '.' + fdp[1]);
    } else {
        if (fdp_txt) {
            fdp_txt.innerHTML = label_zero;
            fdp_txt.classList.remove('not_eligible');
        }
    }

    let totalAmountElt = document.querySelector(".cart-recap-price.total");
    let total = fdp_to_calc + parseFloat(totalAmountElt.getAttribute('data-amount'));
    getFormattedPrice(total, ".cart-recap-price.total", label_zero);

    let total_net = Math.round((basket_raw + fdp_to_calc + corse) * 100) / 100;
    total_net = splitThousands(total_net);

    let upsellingPrice = document.querySelector('.upselling.price');
    if (upsellingPrice) {
        if (fdp_to_calc > 0 && parseFloat(upsellingPrice.getAttribute('data-upselling')) > 0) {
            upsellingPrice.style.display = '';
        } else {
            upsellingPrice.style.display = 'none';
        }
    }

    if (total_net < 0) {
        total_net = 0;
    }

    let tab_total_net = total_net.toString().split('.');
    if (!tab_total_net[1]) {
        tab_total_net[1] = '00';
    } else if (tab_total_net[1].length == 1) {
        tab_total_net[1] += '0';
    }

    let total_cents = tab_total_net[1];
    if (comma !== '') {
        total_cents = comma + total_cents;
    }

    let unitElem = $price_format_plain_tunnel.find('.unit');
    if (unitElem) unitElem.html(tab_total_net[0]);
    if (cent_format_plain_tunnel) cent_format_plain_tunnel.html(total_cents);

    let montant_txt = document.getElementById('montant_txt');
    if (montant_txt) montant_txt.innerHTML = '';
    if (montant_txt) montant_txt.appendChild($price_format_plain_tunnel);

    let nc = montant_txt ? montant_txt.querySelector('.number_cent') : null;
    let sep = montant_txt ? montant_txt.querySelector('.separate') : null;
    if (tab_total_net[1] > 0) {
        if (nc) nc.classList.remove('no_cents');
        if (sep) sep.classList.remove('no_cents');
    } else {
        if (nc) nc.classList.add('no_cents');
        if (sep) sep.classList.add('no_cents');
    }

    if (!obj.classList.contains('disabled')) {
        let radio = obj.querySelector('input.choix_livraison[type=radio]');
        if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        document.querySelectorAll('.delivery_choice').forEach(function(elem) {
            elem.classList.remove('selected', 'active');
        });
        obj.closest('.delivery_choice').classList.add('selected', 'active');
    }

    let livr_dom = document.getElementById('livr_dom');
    let conveyor_id_input = document.getElementById('conveyor_id');
    let relay_network = document.getElementById('relay_network');
    let relay_network_livraion = document.getElementById('relay_network_livraion');
    let relay_type_input = document.getElementById('relay_type');

    if (livr_dom) {
        let radio = obj.querySelector('input.choix_livraison[type=radio]');
        if (radio) livr_dom.value = radio.value;
    }
    if (conveyor_id_input) conveyor_id_input.value = dataTransporteur;
    if (relay_network && relay_network_livraion) relay_network.value = relay_network_livraion.value;
    if (relay_type_input) relay_type_input.value = relayType;

    if (typeof use_cookie_rememmber_conveyor !== 'undefined' && use_cookie_rememmber_conveyor) {
        document.cookie = "WSHOP_CONVEYOR=" + dataTransporteur + "|" + (!is_relay) + ";expires=0; path=/";
    }

    let deliveryAddressHome = document.getElementById('delivery_address_recap_domicile');
    let deliveryAddressOther = document.getElementById('delivery_address_recap_other');
    let billingAddresHome = document.getElementById('billing_address_recap_domicile');

    let conveyorType = obj.getAttribute('data-conveyor-type');
    if (conveyorType === 'relay' || conveyorType === 'store') {
        let transporteurInfo = obj.parentElement.querySelector('.relay-switch-wrapper');
        let relayName = transporteurInfo ? transporteurInfo.querySelector('.shop_name')?.innerHTML : '';
        let relayAddress = transporteurInfo ? transporteurInfo.querySelector('.address')?.innerHTML : '';
        let relayLabel = conveyorType === 'relay' ? 'livraison_dans_relais' : 'livraison_en_magasin';
        let customerFullName = document.querySelector('.bill .infos .full_name')?.innerHTML || '';

        let addrLabel = deliveryAddressOther ? deliveryAddressOther.querySelector('.addr_label') : null;
        let fullNameElem = deliveryAddressOther ? deliveryAddressOther.querySelector('.full_name') : null;
        let fullAddressElem = deliveryAddressOther ? deliveryAddressOther.querySelector('.full_address') : null;
        let customerFullNameElem = deliveryAddressOther ? deliveryAddressOther.querySelector('.customer_full_name') : null;

        if (addrLabel) addrLabel.innerHTML = Translator.translate(relayLabel);
        if (fullNameElem) fullNameElem.innerHTML = relayName;
        if (fullAddressElem) fullAddressElem.innerHTML = relayAddress;
        if (customerFullNameElem) customerFullNameElem.innerHTML = customerFullName;

        if (deliveryAddressHome && deliveryAddressHome.hasAttribute('is-displayed')) {
            slideUp(deliveryAddressHome, 300);
            slideDown(deliveryAddressOther, 300, 'grid');
        }

        if (billingAddresHome && billingAddresHome.hasAttribute('is-displayed')) {
            slideUp(billingAddresHome, 300);
            slideDown(billingAddresHome, 300, 'grid');
        }
    } else {
        if (relay_network) relay_network.value = '';
        if (deliveryAddressOther) slideUp(deliveryAddressOther, 300);
        if (deliveryAddressHome) slideDown(deliveryAddressHome, 300, 'grid');
        if (billingAddresHome) slideDown(billingAddresHome, 300, 'grid');

        let conveyorId = obj.getAttribute('data-id-transporteur') !== null ? obj.getAttribute('data-id-transporteur') : false;
        if (conveyorId && deliveryAddressHome) {
            deliveryAddressHome.dataset.conveyorId = conveyorId;
            deliveryAddressHome.setAttribute('data-conveyorId', conveyorId);
        }

        if (conveyorId && billingAddresHome) {
            billingAddresHome.dataset.conveyorId = conveyorId;
            billingAddresHome.setAttribute('data-conveyorId', conveyorId);
        }
    }
}

document.querySelectorAll('.delivery-type-btn').forEach(function(btn) {
    btn.addEventListener('click', function (e) {
        if (!btn.classList.contains('selected')) {
            document.querySelectorAll('.delivery-type-btn').forEach(function(b) {
                b.classList.remove('selected');
            });
            document.querySelectorAll('.delivery_choice').forEach(function(dc) {
                dc.classList.remove('selected');
                slideUp(dc);
            });

            let deliveryType = btn.getAttribute('data-delivery-type');
            btn.classList.add('selected');

            // Select the first carrier of the chosen delivery method
            let firstConveyor = document.querySelector('.delivery_choice.' + deliveryType);
            let firstConveyorId = firstConveyor.querySelector('.choix_delivery').getAttribute('data-id-transporteur');

            document.querySelectorAll('.delivery_choice.' + deliveryType).forEach(function(dc) {
                var currentConveyorId = dc.querySelector('.choix_delivery').getAttribute('data-id-transporteur');
                if (currentConveyorId == firstConveyorId) {
                    dc.classList.add('selected');
                }
                slideDown(dc);
            });

            document.querySelectorAll('.delivery_lightbox').forEach(function(dl) {
                dl.removeAttribute('modal-open');
            });

            if (firstConveyor) {
                let choixDelivery = firstConveyor.querySelector('.choix_delivery');
                if (choixDelivery && typeof chooseTransporteur === "function") {
                    chooseTransporteur(choixDelivery, choixDelivery.getAttribute('data-id-transporteur'));
                }
            }
        }
    });
    btn.addEventListener('touchstart', function (e) {
        btn.click();
    });
});

document.querySelectorAll('.delivery_choice').forEach(function(elem) {
    elem.addEventListener('click', function(e) {
        // Ignore clicks bubbling up from the address lightbox nested inside the tile (e.g. modify-delivery-addr)
        if (e.target.closest('.modal')) {
            return;
        }
        let choixDelivery = this.querySelector('.choix_delivery');
        if (typeof chooseTransporteur === "function") {
            chooseTransporteur(choixDelivery, choixDelivery.getAttribute('data-id-transporteur'));
        }
    });
});

// On page load, select the pre-selected delivery choice if any
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.delivery_choice.selected')) {
        const selectedChoice = document.querySelector('.delivery_choice.selected');
        const choixDelivery = selectedChoice.querySelector('.choix_delivery');
        if (typeof chooseTransporteur === "function") {
            chooseTransporteur(choixDelivery, choixDelivery.getAttribute('data-id-transporteur'));
        }
    }

    const cartRecap = document.querySelector('.cart-recap');

    if (cartRecap) {
        const linesWrapper = cartRecap.querySelector('.cart-recap-lines-wrapper') || document.createElement('div');
        if (!linesWrapper.classList.contains('cart-recap-lines-wrapper')) {
            linesWrapper.className = 'cart-recap-lines-wrapper';
            const recapLines = cartRecap.querySelectorAll('.cart-recap-line');
            if (recapLines.length > 0) {
                recapLines[0].parentNode.insertBefore(linesWrapper, recapLines[0]);
                recapLines.forEach(line => linesWrapper.appendChild(line));
            }
        }

        const placeholder = document.createElement('div');
        placeholder.className = 'cart-recap-placeholder';
        cartRecap.parentNode.insertBefore(placeholder, cartRecap.nextSibling);

        let isStickyActive = false;

        function handleCartRecapSticky() {
            const placeholderRect = placeholder.getBoundingClientRect();
            const triggerOffset = 50;

            const shouldBeSticky = placeholderRect.bottom < -triggerOffset;

            if (shouldBeSticky && !isStickyActive) {
                isStickyActive = true;
                placeholder.style.width = cartRecap.offsetWidth + 'px';
                placeholder.style.height = cartRecap.offsetHeight + 'px';
                cartRecap.classList.add('is-sticky');

                requestAnimationFrame(() => {
                    cartRecap.classList.add('is-visible');
                });
            } else if (!shouldBeSticky && isStickyActive && placeholderRect.top >= -triggerOffset) {
                isStickyActive = false;
                cartRecap.classList.remove('is-visible');
                placeholder.style.height = '0px';

                setTimeout(() => {
                    if (!isStickyActive) {
                        cartRecap.classList.remove('is-sticky');
                    }
                }, 400);
            }
        }

        window.addEventListener('scroll', handleCartRecapSticky, { passive: true });
        handleCartRecapSticky();
    }
});

function changeRelay(elem, relayId, country = '') {
    let fullAddress = '';
    let relayElem = document.getElementById('relay-' + relayId);
    if (typeof woosmap_provider !== 'undefined' && woosmap_provider) {
        relayId = elem;
        elem = document.getElementById('relay-' + elem);
        let relayAddresseElem = elem ? elem.querySelector('.address') : null;
        let relayAddresse = relayAddresseElem ? relayAddresseElem.textContent.trim() : '';
        fullAddress = relayAddresse;
    } else {
        let addressInput = relayElem ? relayElem.querySelector('[name="relay-address"]') : null;
        fullAddress = addressInput ? addressInput.value : '';
    }
    let relayType = relayElem && relayElem.dataset.relayType !== undefined ? relayElem.dataset.relayType : 0;

    let livrRelais = document.getElementById('livr_relais');
    let deliveryStore = document.getElementById('livr_store');
    let livrDom = document.getElementById('livr_dom');
    let relayCountry = document.getElementById('relay_country');
    let relayTypeInput = document.getElementById('relay_type');
    if (livrRelais) livrRelais.value = relayId;
    if (livrDom) livrDom.value = relayId;
    if (deliveryStore) deliveryStore.value = relayId;

    if (relayCountry) relayCountry.value = country;
    if (relayTypeInput) relayTypeInput.value = relayType;

    let relayNameElem = relayElem ? relayElem.querySelector('.kpname') : null;
    let relayName = relayNameElem ? relayNameElem.innerHTML : '';
    let relayAddress = fullAddress;

    let deliveryChoiceActive = document.querySelector('.delivery_choice.active');
    if (deliveryChoiceActive) {
        let shopNameElem = deliveryChoiceActive.querySelector('.shop_name');
        let adresseElem = deliveryChoiceActive.querySelector('.address');
        if (shopNameElem) shopNameElem.innerHTML = relayName;
        if (adresseElem) adresseElem.innerHTML = relayAddress;

        let clickandgoScheduleElem = relayElem ? relayElem.querySelector('.clickandgo_schedule') : null;
        if (clickandgoScheduleElem) {
            let relaySchedule = clickandgoScheduleElem.innerHTML;
            let transporteurScheduleElem = deliveryChoiceActive.querySelector('.transporteur_clickandgo_schedule');
            if (transporteurScheduleElem) transporteurScheduleElem.innerHTML = relaySchedule;
        } else if (relayElem) {
            let relayScheduleElem = relayElem.querySelector('.table_horaire');
            let relayScheduleTodayElem = relayElem.querySelector('.todayHours');
            let relaySchedule = relayScheduleElem ? relayScheduleElem.innerHTML : '';
            let relayScheduleToday = relayScheduleTodayElem ? relayScheduleTodayElem.innerHTML : '';
            let oldClass = 'close_today';
            let horaireRelay;
            if (deliveryChoiceActive.querySelector('.horaire_today')) {
                horaireRelay = deliveryChoiceActive.querySelector('.horaire_today');
                oldClass = 'horaire_today';
            } else {
                horaireRelay = deliveryChoiceActive.querySelector('.close_today');
            }

            let closedText = Translator.translate('closed');
            let htmlDiv, classDiv;
            if (relayScheduleToday === closedText) {
                htmlDiv = closedText;
                classDiv = 'close_today';
            } else {
                htmlDiv = relayScheduleToday;
                classDiv = 'horaire_today';
            }
            if (horaireRelay) {
                horaireRelay.classList.remove(oldClass);
                horaireRelay.classList.add(classDiv);
                horaireRelay.innerHTML = htmlDiv;
            }

            // Parse schedule table
            const parser = new DOMParser();
            const doc = parser.parseFromString(`<table>${relaySchedule}</table>`, "text/html");
            const rows = doc.querySelectorAll("tbody tr td");

            let updatedSchedule = "";

            rows.forEach(td => {
                let [day, hours] = td.innerHTML.split(": ");
                let formattedHours = hours
                    ? hours.replace(/<br\s*\/?>/g, " et ").replace(/\s*-\s*/g, "-")
                    : closedText;

                updatedSchedule += `<p><span class="title_week">${day.trim()}</span> <span class="timetable_week">${formattedHours}</span></p>\n`;
            });

            let blocHorairesHoraire = deliveryChoiceActive.querySelector('.bloc_horaires .horaire');
            if (blocHorairesHoraire) {
                blocHorairesHoraire.innerHTML = updatedSchedule;
            }
        }
    }

    let relayLabel = relayElem && relayElem.dataset.conveyorType === 'relay' ? 'livraison_dans_relais' : 'livraison_en_boutique';

    let addrLabelElem = document.querySelector('#delivery_address_recap_other .addr_label');
    let fullNameElem = document.querySelector('#delivery_address_recap_other .full_name');
    let fullAddressElem = document.querySelector('#delivery_address_recap_other .full_address');
    if (addrLabelElem) addrLabelElem.innerHTML = Translator.translate(relayLabel);
    if (fullNameElem) fullNameElem.innerHTML = relayName;
    if (fullAddressElem) fullAddressElem.innerHTML = relayAddress;

    let deliveryLightbox = document.querySelector('.delivery_lightbox');
    if (deliveryLightbox) {
        document.querySelectorAll('.delivery_lightbox').forEach(function(dl) {
            dl.removeAttribute('modal-open');
        });
    }
    if (typeof toggleBackdrop === 'function') toggleBackdrop();

    // add custom event when the user has chosen a store
    var evt = new CustomEvent('changeRelay_complete_tunnel', {detail: {conveyor_id: conveyorId, store_id: relayId, country: country}});
    window.dispatchEvent(evt);
}

async function selectChangeAdr(elem) {
    var obj = elem;
    var obj_val = obj.value;
    var id_transp = obj.id;
    var data = {};
    var changeContainer = obj.closest(".adresse_change")?.querySelector(".wrapper_form_adresse");

    data.act = "ajout";
    data.id_transp = id_transp;
    data.no_encode_ajax = true;
    data.modif_type = "ajax";

    if (obj_val !== "") {
        if (obj_val !== "0") {
            data.idAdresse = obj_val;
            data.act = "modif";
        }

        if (changeContainer && changeContainer.classList.contains("show")) {
            changeContainer.classList.remove("show");
            changeContainer.style.display = "none";
            changeContainer.innerHTML = "";
        }

        // Build query string
        const params = new URLSearchParams(data).toString();
        try {
            const response = await fetch(path_relative_root + "livraison-ajax.php?" + params, { method: "GET" });
            const html = await response.text();

            // Parse response HTML
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            var minForm = doc.querySelector(".min_form")?.innerHTML || "";
            var form = doc.querySelector("#adresseForm");

            if (changeContainer && form) {
                changeContainer.innerHTML = form.innerHTML + minForm;
                changeContainer.style.display = "none";
                changeContainer.style.display = "";
                changeContainer.classList.add("show");
            }

            if (typeof woosmap_provider === "undefined") {
                if (typeof initialize_google_place === "function") {
                    initialize_google_place("delivery");
                }
            }

            var choixTypeAdresseDelivery = document.querySelector(".choix_type_adresse.delivery");
            if (choixTypeAdresseDelivery) {
                choixTypeAdresseDelivery.querySelectorAll(".type_adresse").forEach(function(typeAdresseElem) {
                    typeAdresseElem.addEventListener("click", function () {
                        if (typeof typeAdresseElem.show_adresse_title === "function") {
                            typeAdresseElem.show_adresse_title(
                                choixTypeAdresseDelivery.querySelectorAll(".type_adresse"),
                                "#adresseTitre"
                            );
                        }
                    });
                });
            }

            var paysSelect = doc.querySelector("#pays");
            var country_select = "";

            if (paysSelect && typeof paysSelect.value !== "undefined") {
                var selectedOption = paysSelect.querySelector(":checked");
                country_select = selectedOption?.dataset.role?.toLowerCase() || "";

                paysSelect.addEventListener("change", function () {
                    var selected = paysSelect.querySelector(":checked");
                    if (selected && typeof selected.dataset.role !== "undefined") {
                        country_select = selected.dataset.role.toLowerCase();
                    }

                    var telephoneInput = doc.querySelector("#telephone");
                    var mobileInput = doc.querySelector("#mobile");
                    if (telephoneInput && typeof telephoneInput.intlTelInput === "function") {
                        telephoneInput.intlTelInput("setCountry", country_select);
                    }
                    if (mobileInput && typeof mobileInput.intlTelInput === "function") {
                        mobileInput.intlTelInput("setCountry", country_select);
                    }
                });
            } else {
                country_select = "fr";
            }
        } catch (e) {
            console.error(e);
        }
    }
}

var inAnime = false;
var activeBlurPhone = true;

function advanceSlide(element, to, callback) {
    "use strict";

    if (!element) return;

    const callbackfn = function () {
        if (callback && typeof callback === "function") {
            return callback();
        }
        return false;
    };

    const isVisible = element.offsetParent !== null;

    // Store height as data attribute
    if (!element.dataset.height || element.dataset.height === "0") {
        if (!isVisible) {
            element.style.display = "block";
            element.style.position = "absolute";
            element.style.opacity = "0";
        }

        element.dataset.height = element.offsetHeight;

        if (!isVisible) {
            element.style.display = "none";
            element.style.position = "";
            element.style.opacity = "";
        }
    }

    const objH = element.dataset.height;

    if (inAnime === false) {
        inAnime = true;

        if (to === "show" && !isVisible) {
            element.style.display = "block";
            element.style.height = "0px";
            element.style.overflow = "hidden";

            let start = null;
            const duration = 400; // durée de l'animation en ms

            function animate(timestamp) {
                if (!start) start = timestamp;
                const progress = timestamp - start;
                const percentage = Math.min(progress / duration, 1);

                element.style.height = (objH * percentage) + "px";

                if (progress < duration) {
                    requestAnimationFrame(animate);
                } else {
                    element.style.height = "";
                    element.style.overflow = "";
                    inAnime = false;
                    callbackfn();
                }
            }

            requestAnimationFrame(animate);
        } else if (to === "hide" && isVisible) {
            element.style.display = "block";
            element.style.height = objH + "px";
            element.style.overflow = "hidden";

            let start = null;
            const duration = 400; // durée de l'animation en ms

            function animate(timestamp) {
                if (!start) start = timestamp;
                const progress = timestamp - start;
                const percentage = Math.min(progress / duration, 1);

                element.style.height = (objH * (1 - percentage)) + "px";

                if (progress < duration) {
                    requestAnimationFrame(animate);
                } else {
                    element.style.display = "none";
                    element.style.height = "";
                    element.style.overflow = "";
                    inAnime = false;
                    callbackfn();
                }
            }

            requestAnimationFrame(animate);
        } else {
            inAnime = false;
        }
    }
}

function initializeMapV2(conveyorId) {
    var componentForm_map = {
        street_number: {
            target: ".relay_choice_" + conveyorId + " #street",
            length: "short_name"
        },
        route: {
            target: ".relay_choice_" + conveyorId + " #street",
            length: "long_name"
        },
        locality: {
            target: ".relay_choice_" + conveyorId + " #city",
            length: "long_name"
        },
        country: {
            target: ".relay_choice_" + conveyorId + " #country",
            length: "short_name"
        },
        postal_code: {
            target: ".relay_choice_" + conveyorId + " #zip",
            length: "short_name"
        }
    };
    // Create the autocomplete object, restricting the search
    // to geographical location types.
    var searchElem = $(".relay_choice_" + conveyorId + " .autocomplete_addr_map")[0];
    var option = {
        types: ["geocode"]
        //,componentRestrictions: { country: [<?php echo $liste_pays_iso; ?>] }
    };

    var autocomplete_map = new google.maps.places.Autocomplete((searchElem), option);
    // Change autocomplete attribute to prevent browser from autofilling
    setTimeout(() => {
        searchElem?.setAttribute('autocomplete', 'new-password');
    }, 200);

    // When the user selects an address from the dropdown,
    // populate the address fields in the form.
    google.maps.event.addListener(autocomplete_map, "place_changed", function (e) {
        fillInAddressGoogle(autocomplete_map, componentForm_map, false, ".relay_choice_" + conveyorId + " .autocomplete_addr_map", "", "", "#zip");
        $(".relay_choice_" + conveyorId + " .autocomplete_addr_map").trigger("place_changed");
        var address = $(".relay_choice_" + conveyorId + " #street").val();
        var zipcode = $(".relay_choice_" + conveyorId + " #zip").val();
        var city = $(".relay_choice_" + conveyorId + " #city").val();
        var country = $(".relay_choice_" + conveyorId + " #country").val();
        var conveyor_id = $(".relay_choice_" + conveyorId).parents('.bloc_livraison').find('.choix_delivery').attr('data-id-transporteur');

        var isStoreRelay = $(".relay_choice_" + conveyorId).hasClass("store");
        // FIX special case if we only have the city
        if (zipcode == "" && city != "") {
            address = city;
            city = '';
        }
        loadMapDelivery(address + "|" + zipcode + "|" + city + "|" + country, conveyorId, conveyor_id, isStoreRelay);
    });

    commonAction(searchElem, autocomplete_map);
}

// Get the place details from the autocomplete object.
function fillInAddressGoogle(resultGoogle, listComponent, activAnime, adrId, noadr, adrDetai, verifTarget) {
    var place = resultGoogle.getPlace();

    var elementId = adrId.replace("#", "");
    var $elementId = $(adrId);

    // On cache le fait que l"adresse autocomplete est invalide
    if ($("#iconInvalid" + elementId).length > 0) {

        $("#iconInvalid" + elementId).hide();
    }

    if (typeof place == "undefined") {

        if ($(adrId).attr("data-visible") !== "persiste") {

            $(adrId).parent().hide();
        }

        if (adrDetai != "") {
            const adrDetaiElement = document.querySelector(adrDetai);
            if (adrDetaiElement) {
                advanceSlide(adrDetaiElement, "show");
            }
        }

        return false;
    } else {
        // Si on definie que le champs de l'adresse doit se caché après utilisation
        if ($(adrId).attr("data-visible") === "hide") {

            //$(adrId).parent().hide();
        }
    }

    var componentLng = place.address_components.length;
    var finalResult = {};
    var getShortCodeCountry;
    var displayed = false;
    var listComponentToArray = Object.getOwnPropertyNames(listComponent);
    var listComponentLength = listComponentToArray.length;
    var listeTypeResult = {};
    var listeElemResult = {};
    var showAdrDetai = false;
    var intermediateResult = {};

    place.address_components.forEach(function (component) {

        var addressType = component.types[0];

        if (listComponent[addressType]) {

            var adressValue = '';

            if ((addressType == "administrative_area_level_1" && component[listComponent[addressType].length] != '') || addressType != "administrative_area_level_1") {
                adressValue = component[listComponent[addressType].length];
                listeElemResult[addressType] = adressValue;
            }

            var valTarget = listComponent[addressType].target;
            if (addressType == "country") {
                getShortCodeCountry = adressValue;
                if (finalResult[valTarget] != undefined) {

                    finalResult[valTarget] = finalResult[valTarget] + " " + adressValue;
                } else {

                    finalResult[valTarget] = adressValue;
                }
            } else {

                if (intermediateResult[valTarget] != undefined) {

                    intermediateResult[valTarget] = intermediateResult[valTarget] + " " + adressValue;
                } else {

                    intermediateResult[valTarget] = adressValue;
                }
            }
        }
    });
    $.each(intermediateResult, function (key) {
        finalResult[key] = intermediateResult[key];
    });

    if (listeTypeResult.postal_code == undefined && listeTypeResult.administrative_area_level_2 != undefined) {

        finalResult[listComponent.postal_code.target] = place.address_components[listeTypeResult.administrative_area_level_2][listComponent.postal_code.length];
    }

    // for (l = 0; l < listComponentLength; l++) {
    listComponentToArray.forEach(function (key) {

        var targetList = listComponent[key].target;

        if (finalResult[targetList] == undefined) {

            finalResult[targetList] = "";
        }

        if (listeElemResult[key] == undefined) {

            showAdrDetai = true;

            // Si on definie que le champs de l"adresse doit toujours être affiché
            if ($(adrId).attr("data-visible") !== "persiste" || $(adrId).attr("data-visible") === "hide") {

                $(adrId).parent().hide();
            }

            if (adrDetai != "") {
                const adrDetaiElement = document.querySelector(adrDetai);
                if (adrDetaiElement) {
                    advanceSlide(adrDetaiElement, "show");
                }
            }
        }
    });
    // }

    if (!showAdrDetai) {

        if ($("#iconValid" + elementId).length == 0) {

            var imgFile = "img/";

            if (typeof mobileApi !== "undefined" && mobileApi === true) {

                imgFile = "img/mobile/";
            }

            var $newImg = $("<img />", {
                id: "iconValid" + elementId,
                class: "valid_form",
                src: path_relative_root + imgFile + "picto_panneau_valid.png"
            }).css({
                opacity: 0
            });

            $elementId.parent().append($newImg);
            $newImg.animate({
                opacity: 1
            }, 600);
        } else {
            $("#iconValid" + elementId).show();
        }

    }

    /* Désactivation des DOM TOM pour le remplissage du pays
    var is_dom = ($.inArray(getShortCodeCountry, ["GP", "GF", "MQ", "RE", "YT"]) != -1);
    var is_tom = ($.inArray(getShortCodeCountry, ["PM", "MF", "BL", "WF", "TF", "NC", "PF"]) != -1);

    getShortCodeCountry = (is_dom) ? "DO" : (is_tom) ? "TO" : getShortCodeCountry;*/

    var array_corres_code_valide = {
        BE: "B",
        // LU: "L",
        MC: "FR",
        FR: "FR",
        DO: "DO",
        TO: "TO"
    };

    if (array_corres_code_valide[getShortCodeCountry] != undefined) {
        getShortCodeCountry = array_corres_code_valide[getShortCodeCountry];
    }
    var finalArray = Object.getOwnPropertyNames(finalResult);

    var finalLng = finalArray.length;

    activeBlurPhone = false;

    // for (j = 0; j < finalLng; j++) {
    finalArray.forEach(function (finalKey) {

        if (activAnime && verifTarget != undefined) {

            if ($(finalKey).is(verifTarget)) {

                if (verifTarget.indexOf("pays") > 0) {
                    $(adrId).data("google-val", getShortCodeCountry);
                    if ($("option[data-name=" + getShortCodeCountry + "]", finalKey).length) {
                        $("option", finalKey).removeAttr("selected");
                        $("option[data-name=" + getShortCodeCountry + "]", finalKey).prop("selected", "selected").trigger("change");
                    } else {
                        activeBlurPhone = true;
                        $("option", finalKey).removeAttr("selected");
                        $("option[data-name=null]", finalKey).prop("selected", "selected").trigger("change");
                        if (displayed == false) {
                            displayed = true;
                            $(noadr).css({
                                display: "block",
                                opacity: 1
                            }).animate({
                                opacity: 0
                            }, function () {
                                $(noadr).css({
                                    display: "none",
                                    opacity: ""
                                });
                                activateAddressError();
                            });
                            setTimeout(function () {
                                $("input", adrDetai).trigger("blur");
                            }, 1000);
                        }
                    }
                }
            } else {
                if (finalKey.indexOf("department") > 0 && $(finalKey)) {
                    $(finalKey).val(finalResult[finalKey]).trigger("change");
                }
                if ($(finalKey).val(finalResult[finalKey]).val() !== "") {
                    $(finalKey).val(finalResult[finalKey]).trigger("blur");
                }
            }
        } else {
            if (finalKey.indexOf("department") > 0 && $(finalKey)) {
                $(finalKey).val(finalResult[finalKey]).trigger("change");
            }
            $(finalKey).val(finalResult[finalKey]);
        }

        // Condition for borne
        if (!document.getElementById('bloc_store_det')) {
            $(finalKey).trigger("change");
        }

    });
    // }

    if (document.getElementById('streetNumber')) {
        $("#adresseLiv").val($('#streetNumber').val() + ' ' + $('#rue').val());
        $("#billadresseLiv").val($('#billstreetNumber').val() + ' ' + $('#billrue').val());
    }

    // Condition for borne
    if (document.getElementById('bloc_store_det')) {
        $(".bloc_input_autocomplete").hide();
    }

    activeBlurPhone = true;

    if (verifTarget != undefined) {
        if (verifTarget.indexOf("pays") > 0) {
            $(adrId).data("google-val", getShortCodeCountry);
        }
        if (verifTarget.indexOf("zip") > 0 && $(adrId).length > 0) {
            $(adrId).data("google-val", getShortCodeCountry + "|" + $(verifTarget).val());
        }
    }

    if (activAnime) {
        var elemLength = Object.getOwnPropertyNames(listComponent).length;
        for (k = 0; k < elemLength; k++) {
            var currentTarget = listComponent[Object.getOwnPropertyNames(listComponent)[k]].target;

            if ($.inArray(currentTarget, finalArray) == -1 && displayed == false) {
                displayed = true;
                $(noadr).css({
                    display: "block",
                    opacity: 1
                }).animate({
                    opacity: 0
                }, function () {
                    $(noadr).css({
                        display: "none",
                        opacity: ""
                    });
                    activateAddressError();
                });
                setTimeout(function () {
                    $("input", adrDetai).trigger("blur");
                }, 1000);
            }
        }
    }

    $(noadr).css({
        display: "block",
        opacity: 1
    }).animate({
        opacity: 0
    }, function () {
        $(noadr).css({
            display: "none",
            opacity: ""
        });
        activateAddressError();
    });

}

function commonAction(searchElem, autcompleteElem) {
    $(searchElem).on({
        "focus": function () {
            geolocate(autcompleteElem);
        }
    });
}

function geolocate(resultGoogle) {
    if (navigator.geolocation && navigator.userAgent.indexOf("Firefox") == -1) {
        navigator.geolocation.getCurrentPosition(function (position) {
            var geolocation = new google.maps.LatLng(
                position.coords.latitude, position.coords.longitude);
            resultGoogle.setBounds(
                new google.maps.LatLngBounds(geolocation, geolocation)
            );
        });
    }
}

(function() {
    const checkedRadio = document.querySelector('input[type=radio].choix_livraison:checked');
    if (checkedRadio) {
        checkedRadio.closest('.delivery_choice').classList.add('selected');
        checkedRadio.closest('.delivery_choice').classList.add('active');
        checkedRadio.closest('.delivery_choice').previousElementSibling.classList.add('selected');
        let deliveryType = checkedRadio.closest('.delivery_choice').getAttribute('data-delivery-mode');
        document.querySelectorAll(".delivery_choice[data-delivery-mode='" + deliveryType + "']").forEach(function(dc) {
            slideDown(dc);
        });
        // update selected shipping fees in the right
        try {
            let carrierId = checkedRadio.closest('.choix_delivery').getAttribute('data-id-transporteur');
            let selectedFees = parseFloat(checkedRadio.getAttribute('data-fdp'));
            let selectedLabelZero = array_transporteurs_datas[carrierId]['label_zero'];
            let totalAmountElt = document.querySelector(".cart-recap-price.total");
            let selectedTotal = selectedFees + parseFloat(totalAmountElt.getAttribute('data-amount'));

            getFormattedPrice(selectedTotal, ".cart-recap-price.total", selectedLabelZero);
            getFormattedPrice(selectedFees, "#fdp-txt", selectedLabelZero);
        } catch (e) {
            return false;
        }
    }

    document.querySelectorAll('.show_delivery_info').forEach(function(elem) {
        elem.addEventListener('click', handleShowDeliveryInfo, false);
        //elem.addEventListener('touchstart', handleShowDeliveryInfo, false);
    });

    /**
     * Handles the display of delivery information modals based on the delivery type selected.
     * Opens either home delivery, billing address, or relay point modals depending on the data attributes.
     *
     * @param {Event} e - The click event object from the delivery option element
     * @param {HTMLElement} e.currentTarget - The element that triggered the event, expected to have dataset properties
     * @param {string} [e.currentTarget.dataset.deliveryHome] - Flag indicating home delivery option
     * @param {string} [e.currentTarget.dataset.billingAddress] - Flag indicating billing address option
     * @param {string} [e.currentTarget.dataset.conveyorId] - The unique identifier for the delivery conveyor/relay
     * @param {string} [e.currentTarget.dataset.conveyorWs] - Web service identifier for the conveyor
     * @param {string} [e.currentTarget.dataset.deliveryStore] - Flag indicating store relay delivery option
     * @returns {void}
     */
    function handleShowDeliveryInfo(e) {
        var elem = e.currentTarget;
        var isDeliveryHome = elem.dataset.deliveryHome !== undefined ? elem.dataset.deliveryHome : false;
        let isBillingAddress = elem.dataset.billingAddress !== undefined ? elem.dataset.billingAddress : false;

        if (isDeliveryHome || isBillingAddress) {
            document.querySelectorAll('.delivery_lightbox').forEach(function(dl) {
                dl.removeAttribute('modal-open');
            });
            toggleBackdrop(0);

            if (document.querySelector('.delivery-type-btn') && !document.querySelector('.delivery-type-btn').classList.contains('selected')) {
                document.querySelector('.delivery-type-btn[data-delivery-type="home_delivery"]').click();
            }

            setTimeout(function() {
                if (isDeliveryHome) {
                    openMultiShad('delivery_home_choice');
                }

                if (isBillingAddress) {
                    openMultiShad('billing_address_choice');
                }
            }, 0);
        } else {
            var relaySwitchWrapper = elem.closest('.relay-switch-wrapper');
            var deliveryInfosWrapper = relaySwitchWrapper ? relaySwitchWrapper.closest('.delivery-infos-wrapper') : null;
            var choixDelivery = deliveryInfosWrapper ? deliveryInfosWrapper.nextElementSibling : null;
            if (choixDelivery && choixDelivery.classList.contains('choix_delivery')) {
                choixDelivery.click();
            }

            var conveyorId = elem.dataset.conveyorId;
            var conveyorWs = elem.dataset.conveyorWs !== undefined ? elem.dataset.conveyorWs : false;
            var isStoreRelay = elem.dataset.deliveryStore !== undefined ? elem.dataset.deliveryStore : false;

            var relayChoiceModal = document.querySelector('.relay_choice_' + conveyorId);
            if (relayChoiceModal && !relayChoiceModal.hasAttribute('modal-open')) {
                document.querySelectorAll('.delivery_lightbox').forEach(function(dl) {
                    dl.removeAttribute('modal-open');
                });
                toggleBackdrop(0);
                openModal('relay_choice_' + conveyorId);

                loadMapDelivery(false, conveyorId, conveyorWs, isStoreRelay);
            }
        }
    }
})();

function getDeliveryData() {
    let deliveryData = {};
    let activeChoice = document.querySelector('.delivery_choice.active');
    if (activeChoice) {
        // Extract texts
        let type = activeChoice.querySelector('span.transporteur_type')?.textContent.trim() || "";
        let id = activeChoice.querySelector('span.transporteur_id')?.textContent.trim() || "";
        let label = (type + " " + id).trim();

        // Extract fdp from the checked input
        let deliveryFeeInput = activeChoice.querySelector('input#livr_postal:checked');
        let hasDeliveryFee = false;
        if (deliveryFeeInput) {
            let fdpValue = deliveryFeeInput.getAttribute('data-fdp');
            hasDeliveryFee = (fdpValue !== null && fdpValue !== "");
        }
        deliveryData = {
            label: label,
            freeDelivery: !hasDeliveryFee  // invert: true if no fee, false if fee exists
        };
    }
    return deliveryData;
}

function pushDeliveryDataToDatalayer() {
    let deliveryData = getDeliveryData();
    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 && Object.keys(deliveryData).length > 0) {
        DataLayerTrigger.addShippingInfo(dl_v3_impressions, dlv3_action_fields, deliveryData.label);
        DataLayerTrigger.addDeliverTypeClick(deliveryData.label, deliveryData.freeDelivery);
    }
}

if (document.querySelector('.payment-mode-btn')) {
    document.querySelectorAll('.payment-mode-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            let paymentMode = btn.getAttribute('data-payment-mode');
            if (btn.classList.contains('actif')) return;

            document.querySelector('.payment-type.actif')?.classList.remove('actif');
            document.querySelector('.payment-mode-btn.actif')?.classList.remove('actif');

            btn.classList.add('actif');
            document.querySelector('.payment-type' + '.' + paymentMode).classList.add('actif');

            if (paymentMode == 'klarna') {
                setTimeout(function () {
                    $('.payment-type' + '.' + paymentMode).click();
                }, 500);
            } else if (paymentMode == 'checkout') {
                try {
                    document.querySelector('unify-payment-widget')?.selectPaymentMethod('cash-register');
                } catch (e) {
                    console.error('Error setting payment method of Unify Payment Widget:', e);
                }
            }
        });
    });
}
